// Global navigation service to avoid React context issues
class NavigationService {
  private navigate: ((path: string) => void) | null = null;

  setNavigate(navigate: (path: string) => void) {
    this.navigate = navigate;
  }

  navigateTo(path: string) {
    if (this.navigate) {
      console.log('Using global navigation service to navigate to:', path);
      this.navigate(path);
    } else {
      console.log('Navigation service not available, using window.location to navigate to:', path);
      window.location.assign(path);
    }
  }
}

export const navigationService = new NavigationService();
